/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BranchGroupWithNetSalesAndOrderCount } from './BranchGroupWithNetSalesAndOrderCount';
import {
    BranchGroupWithNetSalesAndOrderCountFromJSON,
    BranchGroupWithNetSalesAndOrderCountFromJSONTyped,
    BranchGroupWithNetSalesAndOrderCountToJSON,
    BranchGroupWithNetSalesAndOrderCountToJSONTyped,
} from './BranchGroupWithNetSalesAndOrderCount';

/**
 * 
 * @export
 * @interface BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse
 */
export interface BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse {
    /**
     * 
     * @type {Array<BranchGroupWithNetSalesAndOrderCount>}
     * @memberof BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse
     */
    data: Array<BranchGroupWithNetSalesAndOrderCount>;
}

/**
 * Check if a given object implements the BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse interface.
 */
export function instanceOfBusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse(value: object): value is BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponseFromJSON(json: any): BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse {
    return BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponseFromJSONTyped(json, false);
}

export function BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BranchGroupWithNetSalesAndOrderCountFromJSON)),
    };
}

export function BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponseToJSON(json: any): BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse {
    return BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponseToJSONTyped(json, false);
}

export function BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponseToJSONTyped(value?: BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BranchGroupWithNetSalesAndOrderCountToJSON)),
    };
}

